export default "/images/3094c87e38f27baa78dbac4c4dd4cdf3.avif";